export class Dmenu {
    constructor() {
        this.body = {}
        this.html = {}
        this.drawerMenu = {}
        this.drawerMenuScrollContainer = {}
        this.checked = false
        this.pcBuyBtn = {}
    }

    spSubMenuClicked() {
        // サブメニューを閉じる機能 (ドロワーメニュー内のリンクやXボタンなどを押した場合に)
        //this.checked = false;
        this.body.classList.remove('drawer-menu-open');
        this.drawerMenu.checked = false;
    }

    init() {
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];
        this.drawerMenu = document.getElementById('drawer-menu-trigger');
        this.drawerMenuScrollContainer = document.getElementById('drawer-menu-scroll-container');

        if (document.getElementById('drawer-menu-trigger')) {
            // チェックボックス変更時
            this.drawerMenu.addEventListener('click', () => { //定義時のthisの値を拘束
                //console.log('menu trigger changed: ' + this.checked);
                //let scrollpos = window.scrollY || window.pageYOffset;//スクロール位置を保存

                if (this.body.classList.contains('drawer-menu-open')) {
                    //ドロワーメニュー閉じる
                    this.body.classList.remove('drawer-menu-open');
                    this.body.classList.add('drawer-menu-closing');

                    //ドロワーメニュー閉じた後
                    var _this = this;
                    window.setTimeout(function () {
                        _this.body.classList.remove('drawer-menu-closing');
                        _this.body.classList.add('drawer-menu-closed');
                    }, 400);
                } else {
                    //ドロワーメニュー開く
                    this.body.classList.remove('drawer-menu-closed');
                    this.body.classList.add('drawer-menu-open');
                }
            });


            //aタグの場合
            this.spSubMenuLinkElems = this.drawerMenuScrollContainer.querySelectorAll('a:not(.btn-lang)');
            [].forEach.call(this.spSubMenuLinkElems, (elem) => { //定義時のthisの値を拘束
                //envCheck._clickでなくclickかtouchendのタイミングで行った方が安全か
                elem.addEventListener('click', () => { //定義時のthisの値を拘束
                    this.spSubMenuClicked();
                });
            });

            //overlayの場合
            // this.overlayElm = document.getElementById('overlay');
            // this.overlayElm.addEventListener('click', () => {//定義時のthisの値を拘束
            //     console.log('overlay-clicked');
            //     this.spSubMenuClicked();
            // });

            //PC購入ボタン
            // if (document.querySelectorAll('.js-pulldown-container')[0]) {
            //     this.pcBuyBtn = document.querySelectorAll('.js-pulldown-container')[0];
            //     this.pcBuyBtn.addEventListener('click', () => {
            //         this.pcBuyBtn.classList.toggle('is-pulldown-open');
            //     });
            // }
        }

    }

}